import Bundles from "./Bundles.js";
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
const loc = function(key, bundleName = "login", params = [], ignoreIncorrectParams = false) {
  const bundle = getBundle(bundleName);
  if (!bundle) {
    emitL10nError(key, bundleName, "bundle");
    return "L10N_ERROR[" + bundleName + "]";
  }
  let value = bundle[key];
  try {
    params = params && params.slice ? params.slice(0) : [];
    value = sprintf(value, params);
    if (value) {
      return value;
    } else {
      emitL10nError(key, bundleName, "key");
      return "L10N_ERROR[" + key + "]";
    }
  } catch (e) {
    if (!ignoreIncorrectParams) {
      emitL10nError(key, bundleName, "parameters");
    }
    return "L10N_ERROR[" + key + "]";
  }
};
const parseLocale = (locale) => {
  if (/-/.test(locale)) {
    const parts = locale.split("-");
    parts[1] = parts[1].toUpperCase();
    return parts.join("_");
  }
  return locale;
};
function getBundle(bundleName) {
  if (!bundleName) {
    const key = Object.keys(Bundles).filter((k) => typeof k === "object")[0];
    return Bundles[key];
  }
  const locale = parseLocale(getRawLocale());
  return Bundles[`${bundleName}_${locale}`] || Bundles[bundleName];
}
function getRawLocale() {
  var _window, _window$okta;
  return ((_window = window) === null || _window === void 0 ? void 0 : (_window$okta = _window.okta) === null || _window$okta === void 0 ? void 0 : _window$okta.locale) || "en";
}
function emitL10nError(key, bundleName, reason) {
  const event = createCustomEvent("okta-i18n-error", {
    detail: {
      type: "l10n-error",
      key,
      bundleName,
      reason
    }
  });
  if (event) {
    document.dispatchEvent(event);
  }
}
const createCustomEvent = function(event, params) {
  if (typeof window.CustomEvent === "function") {
    return new CustomEvent(event, params);
  } else if (!window.CustomEvent) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: null
    };
    const evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
};
function sprintf(value, params) {
  function triggerError() {
    throw new Error("Mismatch number of variables: " + value + ", " + JSON.stringify(params));
  }
  let oldValue = value, newValue = value;
  for (let i = 0, l = params.length; i < l; i++) {
    const entity = String(params[i]);
    const regex = new RegExp("\\{" + i + "\\}", "g");
    newValue = newValue.replace(regex, entity);
    if (entity === void 0 || entity === null || newValue === oldValue) {
      triggerError();
    }
    oldValue = newValue;
  }
  if (/\{[\d+]\}/.test(newValue)) {
    triggerError();
  }
  return newValue;
}
export { loc };
